'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'meteor';
var width = 512;
var height = 512;
var aliases = [9732];
var unicode = 'f753';
var svgPathData = ['M16 309c0 103.3 83.7 187 187 187 66.7 0 128.4-35.6 161.8-93.3L466.9 226.3c-20.6 1.6-38.7 3-54.2 4.2l8.3-23.2 64.6-180.8-180.8 64.6-23.2 8.3c1.2-15.6 2.6-33.6 4.2-54.2L109.3 147.2C51.6 180.6 16 242.3 16 309zm304 11a128 128 0 1 1 -256 0 128 128 0 1 1 256 0zM144 288a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z', 'M302.5 35.3c-1.3 16.3-2.3 29.9-3.1 40.6L315.9 70 492.5 7 512 0 505 19.5 442 196.1 436.1 212.6c25-1.9 53.4-4.1 59.9-4.6l-9.7 16.8-107.6 185.9C342.3 473.4 275.4 512 203 512 90.9 512 0 421.1 0 309 0 236.6 38.6 169.7 101.3 133.4L287.2 25.7 304 16 302.5 35.3zM304.8 91l-23.2 8.3c1.2-15.6 2.6-33.6 4.2-54.2L109.3 147.2c-57.7 33.4-93.3 95.1-93.3 161.8 0 103.3 83.7 187 187 187 66.7 0 128.4-35.6 161.8-93.3L466.9 226.3c-20.6 1.6-38.7 3-54.2 4.2L421 207.2 485.6 26.4 304.8 91zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM304 320a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM192 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMeteor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;